import { SVGProps } from "react";

const CloseIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.4889 13.3333L10.1555 9.99997M10.1555 9.99997L6.8222 6.66663M10.1555 9.99997L13.4889 6.66663M10.1555 9.99997L6.8222 13.3333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;
